<template>
    <div class="manage_page fillcontain ">
        <!--el-row style="height: 100%;">
            <el-col :span="4"  style="min-height: 100%; background-color: #324057;">
                <component :is="aside"></component>
            </el-col>
            <el-col :span="20" style="height: 100%;overflow: auto;">
                <component :is="header"></component>
                <keep-alive>
                    <router-view></router-view>
                </keep-alive>
            </el-col>
        </el-row-->
        <el-container>
            <el-header :span="4" height="60px">
                <component :is="header"></component>
            </el-header>
            <el-container :span="20" style="height: 100%;overflow: auto;">
                <el-aside >
                    <component :is="aside"></component>
                </el-aside>
                <el-main>
                    <!--router-view></router-view-->
                    <router-view v-if="user.token"></router-view>
                    <div class="login-msg" v-else>
                        <router-link to="/console/login">你还未登录，请先去登录</router-link>
                    </div>
                </el-main>
            </el-container>
        </el-container>
    </div>
</template>

<script>
import Head from '@/components/Head'
import Aside from '@/components/Aside'
import { mapState } from 'vuex'

export default {
    name: 'home',
    computed: mapState({
        user: state => state.user
    }),
    components: {
        Head,
        Aside
    },
    data () {
        return {
            header: Head,
            aside: Aside
        }
    }
    // created: function() {
    // 	$route.path = '/welcome'
    // 	$route.name = 'Welcome'
    // 	console.log($route.path)
    // }

}
</script>

<style>
    .el-header {
        background-color: #409EFF;
        color: white;
        #font-family: "Helvetica Neue",Helvetica,"PingFang SC","Hiragino Sans GB","Microsoft YaHei","微软雅黑",Arial,sans-serif;
        font-family: Helvetica Neue, Helvetica, PingFang SC, Hiragino Sans GB, Microsoft YaHei, SimSun, sans-serif;
        font-size: 30px;
        text-align: left;
        line-height: 60px;
    }
    .el-aside {
        height: 790px;
        background-color: #F2F6FC;
        color: #333;
        text-align: center;
    }
    .el-main {
        height: 790px;
        padding-left: 20px;
        padding-top: 40px;
        background-color: #DCDFE6;
        color: #333;
        text-align: center;
    }
</style>



// WEBPACK FOOTER //
// src/components/Home.vue